import React from 'react';
import Joyride, { CallBackProps, STATUS } from 'react-joyride';
import { useTour } from '../contexts/TourContext';
import { useOnboarding } from '../contexts/OnboardingContext';
import { TOURS } from '../constants/tourDefinitions';

const TourRunner: React.FC = () => {
  const { activeTour, completeTour } = useTour();
  const { tourActive, isOnboardingChatActive } = useOnboarding();

  const handleCallback = (data: CallBackProps) => {
    const { status } = data;
    if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
      if (activeTour) completeTour(activeTour);
    }
  };

  // Yield to the primary first-run onboarding flow. The design-sessions
  // feature-announcement tour auto-fires ~1.2s after load for anyone who hasn't
  // seen it — including brand-new users mid-onboarding — which stacked two tours
  // on top of each other. Suppress it while the onboarding tour or chat is active.
  if (tourActive || isOnboardingChatActive) return null;
  if (!activeTour || !TOURS[activeTour]) return null;

  return (
    <Joyride
      steps={TOURS[activeTour]}
      run={true}
      continuous={true}
      showSkipButton={true}
      showProgress={true}
      callback={handleCallback}
      styles={{
        options: {
          primaryColor: '#3A8C8C',
          zIndex: 10000,
        },
        tooltip: {
          borderRadius: 12,
          fontSize: 14,
        },
        buttonNext: {
          backgroundColor: '#3A8C8C',
          borderRadius: 8,
          minHeight: 44,
          fontSize: 14,
          fontWeight: 600,
        },
        buttonBack: {
          color: '#3A8C8C',
          marginRight: 8,
          fontSize: 14,
        },
        buttonSkip: {
          color: '#64748B',
          fontSize: 14,
        },
      }}
      locale={{
        back: 'Back',
        close: 'Close',
        last: 'Done',
        next: 'Next',
        skip: 'Skip tour',
      }}
    />
  );
};

export default TourRunner;
